 const add = (key, value) => {
    localStorage.setItem(key, value)
}

 const remove=(key)=>{
  localStorage.removeItem(key)
}

const get=(key)=>{
  return localStorage.getItem(key)
}
 const removeAll=()=>{
  localStorage.clear()
}

export default {
  add,
  get,
  remove,
  removeAll
}